import { CommitmentServer } from "@mod/commitment";

export const commitmentServerSorter = (a: CommitmentServer, b: CommitmentServer) => {
  return (b.createdAt ?? "").localeCompare(a.createdAt ?? "");
};
